<script>
    import ChooseTime from '@/online_booking/new/components/appointments/ChooseTime.vue';
    import FillInformation from '@/online_booking/new/components/common_booking/FillInformation.vue';
    import BookingSuccess from '@/online_booking/new/components/appointments/BookingSuccess.vue';
    import BookingSuccessWaitingList from '@/online_booking/new/components/appointments/BookingSuccessWaitingList.vue';
    import ChooseCalendar from '@/online_booking/new/components/appointments/ChooseCalendar.vue';
    import ChooseProduct from '@/online_booking/new/components/appointments/ChooseProduct.vue';
    import ChooseAddonProduct from '@/online_booking/new/components/appointments/ChooseAddonProduct.vue';
    import Payment from '@/online_booking/new/components/common_booking/Payment.vue';
    import ConfirmBooking from '@/online_booking/new/components/common_booking/ConfirmBooking.vue';
    import Login from '@/online_booking/new/components/Login.vue';
    import LoginCode from '@/online_booking/new/components/LoginCode.vue';
    import ChooseLoginUser from '@/online_booking/new/components/ChooseLoginUser.vue';
    import ChooseLoginOrSignup from '@/online_booking/new/components/ChooseLoginOrSignup.vue';
    import SignUp from '@/online_booking/new/components/SignUp.vue';
    import ChooseUser from '@/online_booking/new/components/ChooseUser.vue';
    import onlineBookingStore from '../store';
    import OnlineBookingSidebarSteps from '@/online_booking/new/components/common/OnlineBookingSidebarSteps.vue';
    import BookingSummary from '@/online_booking/new/components/common_booking/BookingSummary';
    import { http } from '@/system/http.js';
    import { mapState, mapActions, mapGetters } from 'vuex';
    import { getQueryParam } from '@/system/helpers/index.js';
    import { bookingModules, bookingKeys } from '@/online_booking/new/helpers/constants';
    import LoginFlow from '@/online_booking/new/components/LoginFlow.vue';


    export default {

        data: function () {
            return {
                showConfirmation: false,
                showConfirmationWaitingList: false,
                codeSent: false,
                online_booking_settings: null,
                user: null,
                requiredLogin: false,
                logged_in_client: false,
                loginAtTheEndOfFlow: false,
                loading: false,
                permalink: permalink,
                gmaps_url: null,
                paragraphHeight: 0,
                signUp: false,
                loginDesc: null,
                loginSignupFlow: 'chooseLoginOrSignup',
                chooseFromLogin: true,
                settingsLogin: null,
                can_book_multiple_products: false,
                addon_services: true,
                calendarsForOnlineBooking: [],
            }
        },

        beforeUnmount() {
            this.$event_bus.$off('finish');
            this.$event_bus.$off('signMeOut');
            this.$event_bus.$off('booking-restart');
            this.$event_bus.$off('LoadData');
            this.$event_bus.$off('goLogin');
            this.$event_bus.$off('goSignUp');
            this.$event_bus.$off('goLoginOrSignUp');
            this.$event_bus.$off('codeSent');
            this.$event_bus.$off('chooseLoginUser');
            this.$event_bus.$off('goBackToChoose');
            this.$event_bus.$off('beforeCode');
            this.$event_bus.$off('loginSuccess');
        },

        beforeMount() {
            this.$store.commit('clearProducts');
            this.setCurrentModule(bookingModules.BOOK_APPOINTMENT);
        },

        mounted() {
            this.$event_bus.$on('finish', (data) => {
                if (data.data.booking) {
                    this.showConfirmation = true;
                } else if (data.data.waiting_list_entry) {
                    this.showConfirmationWaitingList = true;
                }
            });

            this.$event_bus.$on('signMeOut', () => {
                this.signOutAlert = true;
            });

            this.$event_bus.$on('booking-restart', () => {
                this.showConfirmation = false;
                this.showConfirmationWaitingList = false;
            });

            this.$event_bus.$on('LoadData', (data) => {
                this.user = data.user;
                this.settingsLogin = data.settings_login;

                if (this.settingsLogin && this.settingsLogin.allow_create == 0) {
                    this.loginSignupFlow = 'login'
                }
            });


            this.$event_bus.$on('goLogin', () => {
                this.loginSignupFlow = 'login';
            });

            this.$event_bus.$on('goSignUp', () => {
                this.loginSignupFlow = 'signUp';
            });

            this.$event_bus.$on('goLoginOrSignUp', () => {
                this.loginSignupFlow = (this.chooseFromLogin) ? 'login' : 'signUp';

            });

            this.$event_bus.$on('codeSent', (data) => {
                this.loginSignupFlow = 'loginCode';
                this.$event_bus.$emit('codeSent2', data);
            });

            this.$event_bus.$on('chooseLoginUser', (data) => {
                this.loginSignupFlow = 'chooseLoginUser';
                this.$event_bus.$emit('chooseLoginUser2', data);
            });

            this.$event_bus.$on('goBackToChoose', () => {
                this.loginSignupFlow = 'chooseLoginOrSignup';
            });

            this.$event_bus.$on('beforeCode', function(beforeCodeValue) {
                if (beforeCodeValue === 'login') {
                    this.chooseFromLogin = true;
                } else {
                    this.chooseFromLogin = false;
                }
            }.bind(this));

            this.$event_bus.$on('loginSuccess', (loginData) => {
                this.handleLoginSuccess(loginData);
            });

            this.init();

        },

        components: {
            ChooseTime: ChooseTime,
            FillInformation: FillInformation,
            BookingSuccess: BookingSuccess,
            BookingSuccessWaitingList: BookingSuccessWaitingList,
            Login: Login,
            LoginCode: LoginCode,
            ChooseLoginUser: ChooseLoginUser,
            ChooseUser: ChooseUser,
            ChooseCalendar: ChooseCalendar,
            ChooseProduct: ChooseProduct,
            ChooseAddonProduct: ChooseAddonProduct,
            Payment: Payment,
            ConfirmBooking: ConfirmBooking,
            SignUp: SignUp,
            ChooseLoginOrSignup: ChooseLoginOrSignup,
            OnlineBookingSidebarSteps: OnlineBookingSidebarSteps,
            BookingSummary: BookingSummary,
            LoginFlow: LoginFlow,
        },

        methods: {
            ...mapActions('OnlineBooking', [
                'setOnlineBooking2ndStep',
                'setCurrentModule',
                'setWaitingListOnly',
                'setCalendarsCount',
                'setOnlineBookingSettings',
                'setLoginAtTheEndOfFlow',
                'setLoggedInClient',
                'setLoginRequired',
                'setCurrentStep',
                'setSelectedValue',
            ]),

            async init() {
                this.$event_bus.$emit('booking-restart');
                this.loading = true;

                const giftcard = await this.loadGiftcard();

                http.get(`/book/${this.permalink}/get`)
                    .then(({ data }) => {
                        if (data.online_booking_settings.waiting_list_only) {
                            this.setWaitingListOnly(true);
                        }

                        this.calendarsForOnlineBooking = data.calendars_for_online_booking;
                        this.setCalendarsCount(data.calendars_for_online_booking.length);
                        this.online_booking_settings = data.online_booking_settings;
                        // Todo: refactor this to use the state in this component
                        this.setOnlineBookingSettings(data.online_booking_settings);
                        this.can_book_multiple_products = data.online_booking_settings.allow_selection_of_multiple_products;
                        this.user = data.user;
                        this.gmaps_url = data.gmaps_url;
                        this.logged_in_client = data.logged_in_client;

                        this.setLoggedInClient(data.logged_in_client);
                        this.setLoginAtTheEndOfFlow(data.settings_login.login_end_flow);

                        if (data.settings_login) {
                            this.loginDesc = data.settings_login.description_formatted;
                        }

                        this.$event_bus.$emit('LoadData', data);

                        if (giftcard) {
                            this.$store.commit('setGiftcard', giftcard);
                            this.preselectProductFromGiftcard(data.product_groups);
                            this.$event_bus.$emit('giftcardSelected', giftcard);
                        }

                        if (data.settings_login.active && data.settings_login.require_login && !this.logged_in_client) {
                            this.requiredLogin = true;
                            this.setLoginRequired(true);
                        }

                        this.loginAtTheEndOfFlow = data.settings_login.login_end_flow;

                        this.loading = false;
                        this.setOnlineBooking2ndStep(data.online_booking_settings.second_step);
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },

            handleLoginSuccess(loginData) {
                http.get(`/book/${this.permalink}/get`)
                    .then(({ data }) => {
                        // Update local state first
                        this.logged_in_client = data.logged_in_client;
                        this.user = data.user;

                        // Update Vuex state
                        this.setLoggedInClient(true);
                        this.setSelectedValue({ key: 'login', value: true });

                        // Update the sidebar with logged-in user name
                        this.setSelectedValue({
                            key: bookingKeys.FILL_INFORMATION,
                            value: data.logged_in_client ? data.logged_in_client.name : ''
                        });

                        // Emit a specific event for client login (not LoadData that resets the whole flow)
                        this.$event_bus.$emit('ClientLoggedIn', {
                            logged_in_client: data.logged_in_client,
                            user: data.user
                        });

                        // Move to fillInformation step
                        this.setCurrentStep('fillInformation');
                    })
                    .catch((error) => {
                        console.error('Failed to refresh user data after login:', error);
                        this.setLoggedInClient(true);
                        this.setCurrentStep('fillInformation');
                    });
            },

            async loadGiftcard() {
                const giftcardCode = getQueryParam('giftcard');

                if (!giftcardCode) return;

                return await http.get(`/book/${this.permalink}/giftcard/${giftcardCode}`)
                    .then(({ data: giftcard }) => {
                        return giftcard;
                    })
                    .catch(({ error, errorBag }) => {
                        return null;
                    })
            },

            preselectProductFromGiftcard(product_groups) {
                const selectedGiftcard = this.$store.getters.giftcard;

                if (selectedGiftcard && selectedGiftcard.product_id) {
                    for (let group of product_groups) {
                        for (let product of group.products) {
                            if (product.id === selectedGiftcard.product_id) {
                                this.$store.commit('addProduct', product);
                                return;
                            }
                        }
                    }
                }
            },

            toggleParagraph: function (e) {
                $(".expanding-p").toggleClass("expanding-p-expanded");
                $("#chevron").toggleClass("zmdi-chevron-up");
            },

        },

        updated: function () {
            this.paragraphHeight = $('#expanding-p').height();
            if (this.paragraphHeight < 70) {
                $("#chevron").hide();
                $("#expanding-p").addClass("expanding-p-nogradient");
            }
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep', 'loginAtTheEndOfFlow', 'loggedInClient']),
            ...mapGetters('OnlineBooking', ['currentStepNumber']),

            hasAddonsAvailableToSelect() {
                return onlineBookingStore.getters.hasAddonsAvailableToSelect;
            },

            isOnlineBookingActive () {
                return this.currentStep;
            },

            isEmptyOnlineBooking () {
                return this.calendarsForOnlineBooking.length === 0;
            },
        },
    };
</script>


<template>
    <div>
        <div class="text-center" v-show="loading">
            <div class="preloader" ></div>
        </div>

        <div v-show="!loading && (!requiredLogin || loginAtTheEndOfFlow)">
            <div class="row" v-show="!isEmptyOnlineBooking">
                <online-booking-sidebar-steps
                    class="col-md-4"
                    v-show="!showConfirmation && !showConfirmationWaitingList"
                    :title="trans('online_booking.appointments.title')"
                />
                <div
                    class="panel-group col-md-8"
                    id="booking-accordion"
                    role="tablist"
                    aria-multiselectable="false"
                    v-show="!showConfirmation && !showConfirmationWaitingList"
                >
                    <choose-calendar :permalink="permalink" id="first_step"></choose-calendar>
                    <choose-product :permalink="permalink" :multiple="can_book_multiple_products"></choose-product>
                    <choose-addon-product v-if="addon_services" v-show="hasAddonsAvailableToSelect"></choose-addon-product>
                    <choose-calendar :permalink="permalink" id="second_step"></choose-calendar>
                    <choose-time :user="user"></choose-time>
                    <choose-calendar :permalink="permalink" id="third_step"></choose-calendar>

                    <!-- Login step -->
                    <div v-if="currentStep === 'login'">
                        <login-flow
                            :login-desc="loginDesc"
                            :settings-login="settingsLogin"
                            :login-signup-flow="loginSignupFlow"
                            :choose-from-login="chooseFromLogin">
                        </login-flow>
                    </div>
                    <!-- End of login step -->

                    <fill-information></fill-information>
                    <choose-user></choose-user>
                    <confirm-booking></confirm-booking>
                    <payment></payment>
                    <booking-summary
                        :isLoginScreen="requiredLogin"
                        class="hidden-md hidden-lg hidden-xl"
                    ></booking-summary>
                </div>
            </div>
            <div v-show="isEmptyOnlineBooking">
               <ep-banner>
                   {{ trans('online_booking.nothing_to_book') }}
               </ep-banner>
            </div>
            <transition name="slideUpConfirm">
                <booking-success v-show="showConfirmation"></booking-success>
            </transition>

            <transition name="slideUpConfirm">
                <booking-success-waiting-list v-show="showConfirmationWaitingList"></booking-success-waiting-list>
            </transition>
        </div>

        <div v-show="requiredLogin && !loginAtTheEndOfFlow && !loading">
            <login-flow
                :login-desc="loginDesc"
                :settings-login="settingsLogin"
                :login-signup-flow="loginSignupFlow"
                :choose-from-login="chooseFromLogin">
            </login-flow>
        </div>
    </div>
</template>
